import { Code, Guid, ICodeBaseModel, TNikanDate } from '@/interfaces/base'
import { PersonnelCategory } from './personnel-category'
import { SavingBox } from './saving-box'
import { PersonnelLoan } from './personnel-loan'
import { PersonnelFiscalPeriod } from './personnel-fiscalperiod'
import { PersonnelGenderTypes } from '@/enums/salary'
import { Contract } from './contract'
import emptyId from '@/statics/empty-id'
import { FloatingCenter } from '../system/floating-center'
import { Bank } from '../system/bank'
import { MetaData } from '../system/meta-data'

export class Personnel implements ICodeBaseModel {
  id: Guid
  code: Code
  imageUrl: string | null
  companyId!: Guid
  isActive: boolean
  firstName: string
  lastName: string
  fatherName: string
  nationalCode: string
  idNumber: string
  issuePlace: string
  gender!: PersonnelGenderTypes
  birthDate: TNikanDate | string
  birthPlace: string
  nationality: string
  religion: string
  address: string
  phone: string | null
  postalCode: string | null
  email: string | null
  mobile1: string | null
  mobile2: string | null
  bankAccountNumber: string | null
  bankCardNumber: string | null
  bankShabaNumber: string | null
  description: string | null
  floatingCenter!: FloatingCenter
  bank!: Bank
  personnelCategories: PersonnelCategory[]
  savingBoxes: SavingBox[]
  personnelLoans: PersonnelLoan[]
  personnelFiscalPeriods: PersonnelFiscalPeriod[]
  contracts: Contract[]
  contract: Contract
  metaDatas: MetaData[]

  constructor() {
    this.id = emptyId
    this.code = ''
    this.isActive = true
    this.firstName = ''
    this.lastName = ''
    this.fatherName = ''
    this.nationalCode = ''
    this.idNumber = ''
    this.issuePlace = ''
    this.birthDate = ''
    this.birthPlace = ''
    this.nationality = ''
    this.religion = ''
    this.address = ''
    this.personnelCategories = []
    this.savingBoxes = []
    this.personnelLoans = []
    this.personnelFiscalPeriods = []
    this.contracts = []
    this.contract = new Contract()
    this.imageUrl = null
    this.phone = null
    this.postalCode = null
    this.email = null
    this.mobile1 = null
    this.mobile2 = null
    this.bankAccountNumber = null
    this.bankCardNumber = null
    this.bankShabaNumber = null
    this.description = null
    this.metaDatas = []
  }
}